
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/sitemap",
      function () {
        return require("private-next-pages/fr/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/sitemap"])
      });
    }
  